import React from "react";
import expectations from "../../components/expectations.jpeg";
import Expectations_for_Credit_Repair from "./Expectations_for_Credit_Repair.pdf";

function CreditRepairExpectations() {
  return (
    <div className="container">
      <div className="banner">
        <img src={expectations} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>Expectations for Credit Repair</h1>
          <p>
            This letter is a template you can use to set the correct
            expectations with clients for credit repair services. Access this
            document via Google Doc's here:{" "}
            <a href="https://drive.google.com/file/d/1oWgp_NXOqye9zSlN_H3PJECFRayKyd1G/view?usp=drive_link">
              Expectations of Credit Repair Template
            </a>
          </p>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={Expectations_for_Credit_Repair}>
            Expectations_for_Credit_Repair.pdf
          </a>
        </div>
      </div>
    </div>
  );
}

export default CreditRepairExpectations;
